import React from 'react';

import { Box, Divider, HStack, Skeleton } from '@rbilabs/universal-components';

const SkeletonElement = () => (
  <Skeleton width={{ base: '$16', md: '$40' }} height="$5" rounded="full" />
);

export const MenuSectionTabsSkeleton = (...props: any[]) => {
  return (
    <Box width="full" {...props}>
      <HStack
        justifyContent="space-between"
        paddingTop={{ base: '$2', md: '$0' }}
        paddingBottom="$2"
        px={{ base: '$8', md: '$32' }}
      >
        <SkeletonElement />
        <SkeletonElement />
        <SkeletonElement />
      </HStack>
      <Divider thickness="2" />
    </Box>
  );
};
